var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"standalone":""}},[_c('main',[_c('v-container',{staticClass:"pa-0 ma-0 white",attrs:{"transition":"slide-x-transition","fluid":""}},[_c('v-card',{attrs:{"flat":true}},[_vm._t("toolbar"),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("footer")],2)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }